// Servicio para interactuar con la API de iTunes (Apple Music Search API)
// API pública de iTunes: https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/iTuneSearchAPI/

class ITunesService {
  constructor() {
    this.baseUrl = 'https://itunes.apple.com/search';
  }

  // Buscar una canción específica para obtener la portada
  async searchTrack(trackName, artistName) {
    try {
      const query = `${trackName} ${artistName}`;
      const params = new URLSearchParams({
        term: query,
        media: 'music',
        entity: 'song',
        limit: '1'
      });

      const response = await fetch(`${this.baseUrl}?${params.toString()}`);

      if (!response.ok) {
        console.warn(`⚠️ iTunes API error: ${response.status}`);
        return null;
      }

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const track = data.results[0];
        return {
          trackId: track.trackId,
          trackName: track.trackName,
          artistName: track.artistName,
          collectionName: track.collectionName,
          artworkUrl100: track.artworkUrl100,
          artworkUrl60: track.artworkUrl60,
          // iTunes permite obtener imágenes de mayor calidad reemplazando el tamaño en la URL
          artworkUrl600: track.artworkUrl100?.replace('100x100', '600x600'),
          artworkUrl1200: track.artworkUrl100?.replace('100x100', '1200x1200'),
          previewUrl: track.previewUrl, // iTunes también tiene previews
          trackViewUrl: track.trackViewUrl,
          trackTimeMillis: track.trackTimeMillis
        };
      }

      return null;
    } catch (error) {
      console.error(`⚠️ Error buscando "${trackName}" en iTunes:`, error);
      return null;
    }
  }

  // Obtener portada de alta calidad
  async getArtwork(trackName, artistName, size = 600) {
    try {
      const trackInfo = await this.searchTrack(trackName, artistName);
      if (trackInfo && trackInfo.artworkUrl100) {
        // Reemplazar el tamaño en la URL para obtener alta calidad
        return trackInfo.artworkUrl100.replace('100x100', `${size}x${size}`);
      }
      return null;
    } catch (error) {
      console.error('Error obteniendo artwork de iTunes:', error);
      return null;
    }
  }

  // Buscar múltiples canciones
  async searchTracks(query, limit = 50) {
    try {
      const params = new URLSearchParams({
        term: query,
        media: 'music',
        entity: 'song',
        limit: limit.toString()
      });

      const response = await fetch(`${this.baseUrl}?${params.toString()}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return data.results.map(track => ({
        trackId: track.trackId,
        trackName: track.trackName,
        artistName: track.artistName,
        collectionName: track.collectionName,
        artworkUrl600: track.artworkUrl100?.replace('100x100', '600x600'),
        previewUrl: track.previewUrl,
        trackViewUrl: track.trackViewUrl
      }));

    } catch (error) {
      console.error('Error buscando canciones en iTunes:', error);
      return [];
    }
  }
}

// Exportar una única instancia
export const itunesService = new ITunesService();
